<template>
  <div v-if="offices" class="page-wrapper">
    <div class="container-custom one-office-heading">
      <OneOfficeHeadingComponent :button-text="$t('learn-more')"
                                 :description="offices.content.description"
                                 :image-url="offices.content.imageUrl[0]"
                                 :title="offices.content.title"
      />
    </div>
    <div v-if="offices.content.information" class="container-custom description-wrapper">
      <TitlesDescriptionComponent :size="'small'" :title="$t('one-office-information-title')"/>
      <DescriptionWYSIWYG :description="offices.content.information"/>
    </div>
    <div v-if="specialists" class="container-custom pb-5">
      <TitlesDescriptionComponent :size="'small'" :title="$t('one-office-specialists-title')"/>
      <SelectedPostsGridCarousel :specialists="specialists"/>
    </div>
    <div v-if="offices.content.imageUrl.length &&  false" class=" gallery-wrapper">
      <GalleryMain :imgUrls="offices.content.imageUrl"/>
    </div>
  </div>

</template>

<script>
import OneOfficeHeadingComponent from "@/components/Components/OneOfficeHeadingComponent/OneOfficeHeadingComponent.vue";
import TitlesDescriptionComponent
  from "@/components/Components/TitlesDescriptionComponent/TitlesDescriptionComponent.vue";

import SelectedPostsGridCarousel from "@/components/Components/SelectedPostsGridCarousel/SelectedPostsGridCarousel.vue";
import GalleryMain from "@/components/Components/GalleryMain/GalleryMain.vue";
import DescriptionWYSIWYG from "@/components/Components/DescriptionWYSIWYG/DescriptionWYSIWYG.vue";

export default {
  name: 'OneOfficeView',
  components: {
    DescriptionWYSIWYG,
    GalleryMain,
    SelectedPostsGridCarousel,
    TitlesDescriptionComponent,
    OneOfficeHeadingComponent
  },
  watch: {
    async '$route'() {
      await this.loadOffices();
    }
  },
  data() {
    return {
      offices: null,
      oneOfficeHeading: {},
      oneOfficeInformation: {},
      oneOfficeSpecialists: {},
      oneOfficeGallery: [],
      specialists: null
    };
  },
  async mounted() {
    await this.loadOffices();
  },
  methods: {
    async loadOffices() {
      const id = this.$route.params.id;
      if (id) {
        this.offices = await this.$store.dispatch("offices/getOffice", {id: id});
        const specialists = await this.$store.dispatch("specialists/getSpecialistsByCategory", {categoryId: id});
        this.specialists = specialists.data
      }

    }
  }
};

</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
}

.one-office-heading {
  margin: 90px 0 20px;
}

.gallery-wrapper {
  background: linear-gradient(0deg, rgba(144, 144, 144, 0) 0%, rgba(241, 231, 225, 0.4) 40%);
  margin-bottom: 100px;
}


@media screen and (min-width: 768px) {
  .one-office-heading {
    margin-top: 120px;
  }

}
</style>